import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef
} from '@angular/core';
import {Subscription} from 'rxjs';
import {TooltipEventsEmitter} from '../../../events/tooltip.events';
import {Position} from '../../../enums/position.enum';
import {Tooltip} from '../../../models/tooltip.model';

@Component({
    selector: 'app-tooltip',
    styleUrls: ['./tooltip.component.scss'],
    templateUrl: './tooltip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipComponent implements OnInit, AfterViewInit, OnDestroy {
    private subscriptions: Subscription[] = [];

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('titleEl') titleEl: ElementRef<HTMLElement>;
    @ViewChild('messageEl') messageEl: ElementRef<HTMLElement>;

    message: string;
    title: string;
    isHeaderless: boolean = false;
    position: Position = Position.Bottom;
    additionalPosition: Position;
    tooltipPosition = Position;
    cursorOffset: number;
    width: number = 50;

    constructor(private readonly tooltipEventsEmitter: TooltipEventsEmitter, private readonly changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.tooltipEventsEmitter.tooltipChanged$.subscribe((tooltip: Tooltip) => {
                this.message = tooltip.message;
                this.title = tooltip.title;
                this.cursorOffset = tooltip.cursorOffset;
                // the tooltip is headerless if no title is provided
                this.isHeaderless = !this.title;
                if (tooltip.position) {
                    this.position = tooltip.position[0];
                    if (tooltip.position[1]) {
                        this.additionalPosition = tooltip.position[1];
                    }
                }
                this.width = 50;
                this.changeDetectorRef.detectChanges();

                if (this.titleEl) {
                    while (this.titleEl.nativeElement.offsetHeight > 20 && this.width < 400) {
                        this.width += 10;
                        this.changeDetectorRef.detectChanges();
                    }
                }
            })
        );

        this.subscriptions.push(
            this.tooltipEventsEmitter.tooltipDirectiveInitialized$.subscribe(() => {
                this.tooltipEventsEmitter.broadcastTooltipElementChanged(this.wrapper.nativeElement);
            })
        );
    }

    ngAfterViewInit() {
        this.tooltipEventsEmitter.broadcastTooltipElementChanged(this.wrapper.nativeElement);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close(e: Event) {
        e.stopPropagation();

        this.wrapper.nativeElement.classList.remove('shown');
        this.tooltipEventsEmitter.broadcastTooltipVisibilityChanged(false);
    }
}
